module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Thunder-3497b147df8b04aebb75179e6635a0de.svg";